@use '@/scss/underscore' as _;

.icon {
  flex-shrink: 0;
}

.applicationName {
  width: 360px;
}
